import { FormattedMessage } from 'react-intl';
import { PoolButton, PoolModal, PoolModalActions, PoolModalContent, PoolModalTitle } from '@synergy/components-next';
import { useState } from 'react';

import { Customer } from '../../../../../../common/models/customer';
import { PoolCustomerAutocompleteList } from '../../../../../../common/components/autocomplete-list/customer-autocomplete-list/pool-customer-autocomplete-list';

interface AddParticipantModalProps {
    open: boolean;
    onClose: () => void;
    onAddParticipant: (customer: Customer) => void;
}

export const AddParticipantModal = (props: AddParticipantModalProps) => {
    const { open, onClose, onAddParticipant } = props;
    const [customer, setCustomer] = useState<Customer | null>(null);

    const handleAdd = () => {
        if (customer) {
            onAddParticipant(customer);
        }
    };

    return (
        <PoolModal open={open} onClose={onClose}>
            <PoolModalTitle>
                <FormattedMessage id="app.demands.detail.addParticipant" />
            </PoolModalTitle>
            <PoolModalContent>
                <PoolCustomerAutocompleteList
                    onSelected={setCustomer}
                    label={<FormattedMessage id="app.demands.detail.participant" />}
                    required={true}
                    isLocked={false}
                />
            </PoolModalContent>
            <PoolModalActions>
                <PoolButton variant="text" onClick={onClose}>
                    <FormattedMessage id="app.common.cancel" />
                </PoolButton>
                <PoolButton variant="contained" onClick={handleAdd}>
                    <FormattedMessage id="app.common.add" />
                </PoolButton>
            </PoolModalActions>
        </PoolModal>
    );
};
